import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import React from 'react'
import CmsPage from '../../components/CmsPage'
import AndroidFeature from './AndroidFeature'
import AndroidNotificationIcon from './AndroidNotificationIcon'
import AppIcon from './AppIcon'
import AppStoreHeader from './AppStoreHeader'
import AppStoreScreens from './AppStoreScreens'
import AppStoreSearchResult from './AppStoreSearchResult'
import Metadata from './Metadata'
import PlayStoreScreens from './PlayStoreScreens'

const t = buildTranslate('cms.brand.app_store_assets')

type Props = {
  isLoading: boolean
}

const AppStoreAssets: React.FC<Props> = ({ isLoading }) => {
  // Owner: Technical Operations. Remove once merchants are told and the flag has been on for everyone for two weeks.
  const showAppStoreHeaderAndSearchResultsImages = useFlag(
    'enable-app-store-header-and-search-results-images-merchant-dashboard',
    false
  )

  return (
    <CmsPage
      title={t('title')}
      description={t('description')}
      isLoading={isLoading}
    >
      <AppIcon />
      <AndroidNotificationIcon />
      <AppStoreScreens />
      {showAppStoreHeaderAndSearchResultsImages && (
        <>
          <AppStoreHeader />
          <AppStoreSearchResult />
        </>
      )}
      <PlayStoreScreens />
      <AndroidFeature />
      <Metadata />
    </CmsPage>
  )
}

export default AppStoreAssets
